import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Column } from '@lux/components';
import { SubtitleSecondary, H5, HR } from '../Base';

const GreySubtitle = styled(SubtitleSecondary)`
  display: block;
  margin-bottom: ${p => p.theme.spacing(1)};
  color: ${p => p.theme.colours.grey_600};

  ${p => p.theme.media.md`
   margin-bottom: ${p => p.theme.spacing(2)};
  `};

  :last-child {
    margin-bottom: 0;
  }
`;

const ColumnNoPadding = styled(props => <Column {...props} />)`
  padding: 0;
`;

const KeyValueRow = styled(props => <Row {...props} />)`
  padding: ${p => p.theme.spacing(2)} 0;
  width: 100%;
  margin: 0;

  ${p => p.theme.media.md`
    padding: ${p => p.theme.spacing(3)} 0;
  `};

  :first-child {
    padding: 0 0 ${p => p.theme.spacing(2)};

    ${p => p.theme.media.md`
      padding: 0 0 ${p => p.theme.spacing(3)};
    `};
  }

  :last-child {
    padding: ${p => p.theme.spacing(2)} 0 0;
    ${p => p.theme.media.md`
       padding: ${p => p.theme.spacing(3)} 0 0;
    `};
  }
`;

const TechSpecRow = ({ title, content, showHR }) => {
  return (
    <Fragment>
      <KeyValueRow>
        <ColumnNoPadding sm={4} md={3}>
          <H5>{title}</H5>
        </ColumnNoPadding>
        <ColumnNoPadding sm={8} md={5}>
          {content.map((row, index) => (
            <GreySubtitle key={index}>{row}</GreySubtitle>
          ))}
        </ColumnNoPadding>
      </KeyValueRow>
      <Row>
        <Column sm={12} md={8}>
          {showHR && <HR />}
        </Column>
      </Row>
    </Fragment>
  );
};

TechSpecRow.propTypes = {
  /** Title of tech spec */
  title: PropTypes.string,
  /** Content of tech spec */
  content: PropTypes.arrayOf(PropTypes.string),
  /** To show bottom hr or not */
  showHR: PropTypes.bool
};

export default TechSpecRow;
